import FoodImage1 from '../images/foodImages/pasta/Food_img1.jpg';

const FriedItems = [
  {
    id: 1,
    name: '原味薯條',
    price: 100,
    description: '經典薯條，外脆內軟，香氣十足，令人回味。',
    image: FoodImage1,
  },
  { id: 2, name: '起司薯條', price: 120, description: '酥脆薯條，濃郁起司，每一口都滿足。', image: FoodImage1 },
  { id: 3, name: '20香薯條', price: 150, description: '', image: FoodImage1 },
  { id: 4, name: '洋蔥圈', price: 80, description: '外脆內嫩，洋蔥甜美，香氣四溢，口感豐富。', image: FoodImage1 },
  {
    id: 5,
    name: '起司棒',
    price: 120,
    description: '香脆外層，拉絲起司，濃郁奶香，驚艷每一口。',
    image: FoodImage1,
  },
  { id: 6, name: '雞米花', price: 200, description: '外酥內嫩，鮮嫩雞肉，滋味十足。', image: FoodImage1 },
  { id: 7, name: '綜合三拼盤', price: 280, description: '薯條、起司棒、洋蔥圈，美味三重奏', image: FoodImage1 },
  { id: 8, name: '綜合四拼盤', price: 450, description: '多重享受，一次滿足', image: FoodImage1 },
];

export default FriedItems;
